import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiSettings, FiUser, FiChevronDown, FiEdit3 } from 'react-icons/fi';
import { format } from 'date-fns';

export default function Navbar() {
  const { token, logout, currentUser } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const nav = useNavigate();
  const today = format(new Date(), 'yyyy-MM-dd');

  const handleLogout = () => {
    logout();
    nav('/login');
  };

  return (
    <nav className="navbar modern-navbar">
      <div className="navbar-left">
        <Link to="/">Home</Link>
        <Link to="/browse">Browse Profiles</Link>
        <Link to="/analysis">Analysis</Link>
      </div>
      <div className="navbar-right">
        <button className="theme-toggle" onClick={toggleTheme} title="Toggle theme">
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
        {token && currentUser ? (
          <div className="settings-dropdown">
            <button className="settings-link" aria-label="Settings" tabIndex={0}>
              <FiSettings size={20} style={{ verticalAlign: 'middle' }} />
              <FiChevronDown size={16} style={{ marginLeft: 2, verticalAlign: 'middle' }} />
            </button>
            <div className="settings-dropdown-content">
              <Link to="/profile">Settings</Link>
              <button onClick={handleLogout} className="logout-btn">Logout</button>
            </div>
          </div>
        ) : (
          <>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
          </>
        )}
        {token && currentUser && currentUser.display_name && (
          <span className="navbar-avatar" title={currentUser.display_name}>
            <FiUser size={18} style={{ marginRight: 4 }} />
            {currentUser.display_name}
          </span>
        )}
      </div>
    </nav>
  );
}